import styles from '../styles/About.module.css';

const BIO_LINES = [
  'I architected and built a multi-tenant AI Chatbot SaaS platform on the MERN stack — with PayPal billing, real-time live-agent handoff via Socket.io, role-based team management, and analytics.',
  "I've delivered 100+ custom WordPress websites and rebuilt & manage VPS infrastructure hosting 30+ client sites, alongside technical SEO work that's pushed 20+ sites past a 90+ Google PageSpeed score.",
];

const STATS = [
  { value: 3, suffix: '+', label: 'Years experience' },
  { value: 100, suffix: '+', label: 'Websites delivered' },
  { value: 30, suffix: '+', label: 'Servers managed' },
  { value: 90, suffix: '+', label: 'Avg. PageSpeed score' },
];

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <div className="section-head" data-anim>
          <span className="section-index">01</span>
          <span className="section-rule" />
          <h2 className="section-title">About</h2>
        </div>

        <div className={styles.grid}>
          <div className={styles.card} data-anim data-tilt>
            <div className={styles.cornerTL} />
            <div className={styles.cornerBR} />
            <div className={styles.photo}>
              <img src="/me.png" alt="Muhammad Yaseen" className={styles.photoImg} />
            </div>
            <div className={styles.cardFoot}>
              <div>
                <div className={styles.cardName}>Muhammad Yaseen</div>
                <div className={styles.cardRole}>Full Stack Developer</div>
              </div>
              <div className={styles.available}>
                <span className={styles.availableDot} />
                Available
              </div>
            </div>
          </div>

          <div>
            <p className={styles.bioLine} data-anim-line>
              I&rsquo;m Yaseen, a 22-year-old full-stack developer based in Karachi, Pakistan.
            </p>
            {BIO_LINES.map((line) => (
              <p key={line} className={styles.bioSmall} data-anim-line>
                {line}
              </p>
            ))}

            <div className={styles.stats}>
              {STATS.map((stat) => (
                <div key={stat.label} className={styles.stat} data-anim>
                  <div className={styles.statNumber}>
                    <span data-count={stat.value}>{stat.value}</span>
                    <span className={styles.statSuffix}>{stat.suffix}</span>
                  </div>
                  <div className={styles.statLabel}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
